export function updateUserRun($auth) {
	"ngInject";
	if ($auth.isAuthenticated()) {
		$auth.me();
	}
}


// WEBPACK FOOTER //
// ./sources/bootstrap/updateUser.run.js